export const ALLOWED_MOBILE_ROUTES = [
  'treatment-request',
  'monitoring',
  'monitoring-detail',
  'shipment',
  'edit-shipment',
  'shipment-detail',
  'add-shipment',
  'certificate-export',
  'certificate-graph',
  'certificate-treatment',
  'add-treatment-request',
  'view-treatment-request',
  'edit-treatment-request',
  'page-not-found',
  'login',
  'waiting-approve'
];

export const PUBLISH_ROUTES = [
  'page-not-found',
  'login',
  'reset-password',
  '403',
  'waiting-approve',
  'forgot-password',
  'forgot-password-success'
];
